/**
 * The classroom a student (no account) joined on this device
 * (ClassroomStudentPanel.cs): kept in localStorage.
 */
import type { JoinedClassroom } from "./myProjects";

const KEY = "makeit:student";

export function loadStudent(): JoinedClassroom | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw) as JoinedClassroom;
    return s && typeof s.classroomId === "string" && typeof s.studentId === "string" ? s : null;
  } catch {
    return null;
  }
}

export function saveStudent(s: JoinedClassroom | null): void {
  try {
    if (s) localStorage.setItem(KEY, JSON.stringify(s));
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
